import { render } from "./InputAverageTotal.vue?vue&type=template&id=ab5385aa&ts=true"
import script from "./InputAverageTotal.vue?vue&type=script&lang=ts"
export * from "./InputAverageTotal.vue?vue&type=script&lang=ts"

import "./InputAverageTotal.vue?vue&type=style&index=0&id=ab5385aa&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__